import React, { Fragment } from "react"
import { MainMenuLinks } from "../../constants"
import MainMenuItem from "./menuItem"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import { withStyles } from "@material-ui/core/styles"
import { Link } from "gatsby"
import { FiX } from "react-icons/fi"
import { Typography, List } from "@material-ui/core"
import { useDispatch } from "react-redux"
import * as actionCommon from "../../store/actions/commonActions"
const styles = theme => ({
  ullist: {
    padding: 0,
  },
  listItem: {
    padding: 0,
  },
})
const MainMenu = ({ classes }) => {
  const navLinks = MainMenuLinks()
  const dispatch = useDispatch()
  const mainMenuToggleClosed = event => {
    dispatch(actionCommon.menuMobile(""))
    event.preventDefault()
  }

  return (
    <Fragment>
      <Box component="nav" className="hbku-nav hbku-nav-blue">
        <Link
          to={"/"}
          id="hbku_nav_close"
          className="hbku-nav-close"
          onClick={mainMenuToggleClosed}
        >
          <Typography component="span" className="feather-icon">
            <FiX />
          </Typography>
        </Link>
        <Box component="div" className="nicescroll-bar">
          <Box component="div" className="navbar-nav-wrap">
            <List className={classes.ullist + " " + "navbar-nav flex-row"}>
              {navLinks.map((linkProperties, i) => (
                <MainMenuItem linkProps={linkProperties} key={i} />
              ))}
            </List>
          </Box>
        </Box>
      </Box>
      <Box
        component="div"
        id="hbku_nav_backdrop"
        className="hbku-nav-backdrop"
      ></Box>
    </Fragment>
  )
}

export default withStyles(styles)(MainMenu)
